/* Render through the theme's existing cart components; AMP is updated by the gift module. */
(function () {
  var config = window.PtvReferralGiftConfig;
  if (!config) return;
  var renderTimer;
  var progressTimer;
  var checkingTimer;
  var checkingSince = null;
  var lastProgressPercent = null;

  function progressState() {
    var gift = window.PtvReferralGift;
    return config.progressEnabled !== false && gift && typeof gift.getProgress === 'function' ? gift.getProgress() : null;
  }
  function money(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fi', { style: 'currency', currency: config.currency || 'EUR' }).format(cents / 100);
    } catch (_) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  }
  function formatWelcomeMoney() {
    var welcome = document.getElementById('ptv-referral-welcome');
    var body = welcome && welcome.querySelector('p');
    if (!body || typeof config.welcomeBodyTemplate !== 'string') return;
    // Resolve once, as text: editor copy and product names must never become HTML.
    body.textContent = config.welcomeBodyTemplate.replace(/\[(raja|arvo|lahja)\]/g, function (_, key) {
      return key === 'raja' ? money(config.threshold) : key === 'arvo' ? money(config.giftValue) : config.giftName;
    });
  }
  function createProgress() {
    var section = document.createElement('section');
    section.className = 'ptv-referral-progress-section';
    section.hidden = true;
    var card = document.createElement('div');
    card.className = 'ptv-referral-progress__card';
    section.appendChild(card);
    var header = document.createElement('div');
    header.className = 'ptv-referral-progress__header';
    if (config.giftImageUrl) {
      var image = document.createElement('img');
      image.className = 'ptv-referral-progress__image';
      image.setAttribute('src', config.giftImageUrl);
      image.setAttribute('alt', '');
      image.setAttribute('width', '48');
      image.setAttribute('height', '48');
      image.setAttribute('loading', 'lazy');
      image.setAttribute('decoding', 'async');
      // A missing product image must not leave a broken-image icon in the cart.
      image.addEventListener('error', function () { image.hidden = true; });
      header.appendChild(image);
    }
    var copy = document.createElement('div');
    copy.className = 'ptv-referral-progress__copy';
    var eyebrow = document.createElement('span');
    eyebrow.className = 'ptv-referral-progress__eyebrow';
    eyebrow.appendChild(document.createTextNode(''));
    var title = document.createElement('strong');
    title.className = 'ptv-referral-progress__title';
    title.appendChild(document.createTextNode(''));
    copy.appendChild(eyebrow);
    copy.appendChild(title);
    header.appendChild(copy);
    var value = document.createElement('span');
    value.className = 'ptv-referral-progress__value tier-rewards-summary-item';
    var valueText = document.createElement('span');
    valueText.className = 'ptv-referral-progress__value-text tier-rewards-summary-item-text';
    valueText.appendChild(document.createTextNode(''));
    value.appendChild(valueText);
    header.appendChild(value);
    var message = document.createElement('p');
    message.className = 'ptv-referral-progress__message';
    message.setAttribute('role', 'status');
    message.setAttribute('aria-live', 'polite');
    message.setAttribute('aria-atomic', 'true');
    var check = document.createElement('span');
    check.className = 'ptv-referral-progress__check';
    check.setAttribute('aria-hidden', 'true');
    check.innerHTML = '<svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-check"><path d="M20 6 9 17l-5-5"></path></svg>';
    check.hidden = true;
    message.appendChild(check);
    var before = document.createElement('span');
    before.className = 'ptv-referral-progress__before';
    before.appendChild(document.createTextNode(''));
    var amount = document.createElement('span');
    amount.className = 'ptv-referral-progress__amount ptv-free-shipping-bar__amount';
    amount.appendChild(document.createTextNode(''));
    var after = document.createElement('span');
    after.className = 'ptv-referral-progress__after';
    after.appendChild(document.createTextNode(''));
    message.appendChild(before);
    message.appendChild(amount);
    message.appendChild(after);
    var track = document.createElement('div');
    track.className = 'ptv-referral-progress__track';
    track.setAttribute('role', 'progressbar');
    track.setAttribute('aria-valuemin', '0');
    track.setAttribute('aria-valuemax', '100');
    var fill = document.createElement('span');
    fill.className = 'ptv-referral-progress__fill';
    track.appendChild(fill);
    card.appendChild(header);
    card.appendChild(message);
    card.appendChild(track);
    var hint = document.createElement('p');
    hint.className = 'ptv-referral-progress__hint';
    hint.appendChild(document.createTextNode(''));
    card.appendChild(hint);
    return section;
  }
  function childWithClass(parent, className) {
    return Array.from(parent.children).find(function (node) { return node.classList.contains(className); });
  }
  function mountProgress(parent, before, prepend) {
    var section = childWithClass(parent, 'ptv-referral-progress-section');
    if (!section) section = createProgress();
    if (before && before !== section) {
      if (section.nextElementSibling !== before) parent.insertBefore(section, before);
    } else if (prepend) {
      if (parent.firstElementChild !== section) parent.insertBefore(section, parent.firstChild);
    } else if (section.parentElement !== parent) {
      parent.appendChild(section);
    }
    return section;
  }
  function setAttribute(node, name, value) {
    if (node.getAttribute(name) !== value) node.setAttribute(name, value);
  }
  function setText(node, value) {
    // Keep text nodes stable so AMP's other observers don't treat UI text as new cart content.
    if (node.firstChild.data !== value) node.firstChild.data = value;
  }
  function updateProgress() {
    progressTimer = null;
    var state = progressState();
    var messages = config.progressMessages;
    // An unverified gift is not a progress result. Hide this promotional card
    // instead of displaying an error or retaining a false success message.
    // The gift module still owns reconciliation and checkout error handling.
    if (!state || !messages || state.status === 'unavailable') {
      clearTimeout(checkingTimer);
      checkingTimer = null;
      checkingSince = null;
      lastProgressPercent = null;
      document.querySelectorAll('.ptv-referral-progress-section').forEach(function (section) { section.hidden = true; });
      return;
    }
    var checking = state.status === 'checking';
    if (checking && checkingSince === null) {
      checkingSince = Date.now();
      checkingTimer = setTimeout(queueProgress, 350);
    } else if (!checking) {
      clearTimeout(checkingTimer);
      checkingTimer = null;
      checkingSince = null;
    }
    var sections = [];
    document.querySelectorAll('#slidecarthq .slidecarthq').forEach(function (panel) {
      // Stay outside AMP's replaceable reward/product content, directly after shipping.
      var shipping = childWithClass(panel, 'ptv-free-shipping-section');
      var before = shipping ? shipping.nextElementSibling : childWithClass(panel, 'rewards') || childWithClass(panel, 'items') || childWithClass(panel, 'footer');
      sections.push(mountProgress(panel, before, false));
    });
    document.querySelectorAll('#CartPageForm, #CartDrawerForm .drawer__scrollable').forEach(function (parent) {
      sections.push(mountProgress(parent, null, true));
    });
    var added = state.status === 'added';
    var template = messages[state.status] || messages.checking || '';
    // Remove a previously confirmed result immediately; only the neutral waiting
    // message is delayed, so quick background checks don't flash another sentence.
    if (checking && Date.now() - checkingSince < 350) template = '';
    var amount = state.status === 'remaining' ? money(state.remaining) : added ? money(0) : '';
    var parts = template.split('[amount]');
    var text = parts.join(amount);
    var percent = Math.min(100, Math.max(0, Number(state.percent) || 0));
    sections.forEach(function (section) {
      var message = section.querySelector('.ptv-referral-progress__message');
      if (checking && section.getAttribute('data-status') !== 'checking' && !section.hidden) {
        if (section.getBoundingClientRect) section.style.minHeight = section.getBoundingClientRect().height + 'px';
        if (message.getBoundingClientRect) message.style.minHeight = message.getBoundingClientRect().height + 'px';
      } else if (!checking) {
        section.style.minHeight = '';
        message.style.minHeight = '';
      }
      var compact = added || checking && section.getAttribute('data-layout') === 'compact';
      setAttribute(section, 'data-layout', compact ? 'compact' : 'expanded');
      setAttribute(section, 'aria-busy', checking ? 'true' : 'false');
      setText(section.querySelector('.ptv-referral-progress__eyebrow'), messages.eyebrow || '');
      setText(section.querySelector('.ptv-referral-progress__title'), config.giftName || messages.title || '');
      var value = section.querySelector('.ptv-referral-progress__value');
      setText(value.querySelector('.ptv-referral-progress__value-text'), (messages.value || '').split('[value]').join(money(config.giftValue || 0)));
      value.hidden = !messages.value;
      setAttribute(section, 'data-status', state.status);
      setText(section.querySelector('.ptv-referral-progress__before'), parts[0]);
      setText(section.querySelector('.ptv-referral-progress__amount'), parts.length > 1 ? amount : '');
      setText(section.querySelector('.ptv-referral-progress__after'), parts.slice(1).join(amount));
      section.querySelector('.ptv-referral-progress__check').hidden = !added;
      var track = section.querySelector('.ptv-referral-progress__track');
      var revealTrack = section.hidden || track.hidden;
      track.hidden = compact;
      setAttribute(track, 'aria-label', messages.title || '');
      setAttribute(track, 'aria-valuetext', text);
      setAttribute(track, 'aria-valuenow', String(percent));
      var width = percent + '%';
      var fill = section.querySelector('.ptv-referral-progress__fill');
      // A rebuilt AMP panel starts from the last cart value, never from zero.
      if (!fill.style.width || lastProgressPercent === null) {
        fill.style.width = (lastProgressPercent === null ? percent : lastProgressPercent) + '%';
      }
      var hint = section.querySelector('.ptv-referral-progress__hint');
      setText(hint, (messages.hint || '').split('[threshold]').join(money(config.threshold || 0)));
      hint.hidden = !messages.hint || compact || state.status !== 'remaining' && !checking;
      section.hidden = false;
      // Give a returning track its previous width before changing the target.
      // Visible tracks use the CSS transition directly, including rapid updates.
      if (!compact && revealTrack && fill.style.width !== width) void fill.offsetWidth;
      if ((!compact || added) && fill.style.width !== width) fill.style.width = width;
    });
    lastProgressPercent = percent;
  }
  function queueProgress() {
    if (!progressTimer) progressTimer = setTimeout(updateProgress, 20);
  }
  function observeProgressMounts() {
    formatWelcomeMoney();
    updateProgress();
    if (!window.MutationObserver || !document.body || !config.progressMessages || config.progressEnabled === false) return;
    var selector = '#slidecarthq, #CartPageForm, #CartDrawerForm';
    new MutationObserver(function (records) {
      var changed = records.some(function (record) {
        var target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
        if (target && target.closest('.ptv-referral-progress-section')) return false;
        if (target && target.closest(selector)) return true;
        return Array.from(record.addedNodes).some(function (node) {
          return node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector));
        });
      });
      if (changed) queueProgress();
    }).observe(document.body, { childList: true, subtree: true });
  }
  document.addEventListener('ptv:referral-progress', queueProgress);
  document.addEventListener('ptv:referral-context', queueProgress);
  document.addEventListener('shopify:section:load', queueProgress);
  window.addEventListener('pageshow', queueProgress);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observeProgressMounts, { once: true });
  else observeProgressMounts();

  document.addEventListener('ptv:referral-cart-error', function (event) {
    var error = document.getElementById('ptv-referral-cart-error');
    if (!error) {
      error = document.createElement('p');
      error.id = 'ptv-referral-cart-error';
      error.className = 'text-center';
      error.setAttribute('role', 'alert');
      var form = document.querySelector('#slidecart-checkout-form, #CartPageForm, #CartDrawerForm');
      (form || document.getElementById('MainContent') || document.body).appendChild(error);
    }
    error.textContent = event.detail && event.detail.message || config.messages.cartError;
    error.hidden = false;
  });

  document.addEventListener('ptv:referral-cart-changed', function (event) {
    var cart = event.detail && event.detail.cart;
    if (!cart || !Array.isArray(cart.items)) return;
    var error = document.getElementById('ptv-referral-cart-error');
    if (error) error.hidden = true;
    document.querySelectorAll('.cart-link__bubble-num').forEach(function (node) {
      node.textContent = cart.item_count;
    });
    document.querySelectorAll('.cart-link__bubble').forEach(function (node) {
      node.classList.toggle('cart-link__bubble--visible', cart.item_count > 0);
    });
    // CartForm already owns markup loading, discounts, totals and QtySelector re-init.
    clearTimeout(renderTimer);
    renderTimer = setTimeout(function () {
      if (document.querySelector('#CartPageForm, #CartDrawerForm')) {
        document.dispatchEvent(new CustomEvent('cart:build'));
      }
    }, 80);
  });
})();
